module.exports = __webpack_public_path__ + "media/hearts/white-heart-c7374b85.svg";